export const activeAddressBookModals = {
  DELIVERY: 'delivery',
  BILLING: 'billing',
  POS_CREDIT: 'posCredit',
};

export const ADDRESS_BOOK_MODAL_STATE_KEY = 'activeAddressBookModal';
